export default __webpack_public_path__ + "static/media/ParentsLearningCenterPictureSmall.b6e1698e.jpg";